import React from "react";

import * as styles from "./container.module.css";

const Container = ({ children }) => {
  return <div>{children}</div>;
};

export default Container;
